import { useMemo } from "react";
import {
	consequenceSeverityTable,
	probability_score,
	risk_frequency,
} from "../../stores/consequence-severity-table";

export function RiskMatrixTable() {
	const levels = useMemo(() => ["E", "D", "C", "B", "A"] as const, []);
	const frequencyEntries = useMemo(
		() =>
			Object.entries(risk_frequency).sort(([a], [b]) => Number(a) - Number(b)),
		[]
	);

	const getRiskClass = (code: string) => {
		if (probability_score.HIGH.includes(code)) return "risk-high";
		if (probability_score.MEDIUM.includes(code)) return "risk-medium";
		if (probability_score.LOW.includes(code)) return "risk-low";
		return "";
	};

	return (
		<>
			<table
				className={`risk-matrix-table ${
					localStorage.getItem("theme") === "dark" ? "dark" : ""
				}`}
			>
				<thead>
					<tr>
						<th className="bg-transparent! border-0! fit-col" rowSpan={2}></th>
						<th className="bg-transparent! border-0! fit-col" rowSpan={2}></th>
						<th className="w-auto" colSpan={consequenceSeverityTable.length}>
							Consequence - Type
						</th>
						<th className="w-1/3" colSpan={frequencyEntries.length}>
							Probability/Frequency
						</th>
					</tr>
					<tr>
						{consequenceSeverityTable.map((item, idx) => (
							<th key={idx}>{item.consequence}</th>
						))}
						{frequencyEntries.map(([key, value]) => (
							<th key={key}>
								<div className="flex flex-col items-center justify-center text-center gap-1">
									<span className="text-base font-semibold">{key}</span>
									<span className="text-xs leading-tight opacity-80">
										{value as string}
									</span>
								</div>
							</th>
						))}
					</tr>
				</thead>
				<tbody>
					{levels.map((level, rowIdx) => (
						<tr key={level}>
							{rowIdx === 0 && (
								<td rowSpan={levels.length} className="fit-col">
									<div className="-rotate-90 text-nowrap font-medium">
										Impact/Consequence level
									</div>
								</td>
							)}
							<td className="font-semibold fit-col">{level}</td>
							{consequenceSeverityTable.map((item, cIdx) => (
								<td key={`${level}-c-${cIdx}`} className="text-left align-top">
									{(item.severity_list as any)[level]}
								</td>
							))}
							{frequencyEntries.map(([fKey], fIdx) => {
								const code = `${level}${Number(fKey)}`;
								const colorClass = getRiskClass(code);
								return (
									<td
										key={`${level}-f-${fIdx}`}
										className={`risk-cell ${colorClass}`}
									>
										{code}
									</td>
								);
							})}
						</tr>
					))}
				</tbody>
			</table>
		</>
	);
}

export default RiskMatrixTable;
